import React from "react";
import { Link } from "react-router-dom";

const GuideCTA = ({ nextPillar }) => (
  <section className="guide-cta">
    <div className="guide-cta__banner">Ready to practice</div>
    <div className="guide-cta__layout">
      <div className="guide-cta__body">
        <h2 className="guide-cta__heading">Try it on Ahavibes</h2>
        <p className="guide-cta__text">
          Put this guide into practice with a structured guided reflection — five intentional minutes to
          separate facts from stories.
        </p>
        <Link to="/" className="primary-button guide-cta__button">
          Start a guided reflection
        </Link>
        {nextPillar ? (
          <p className="guide-cta__text" style={{ marginTop: "1rem" }}>
            Continue your learning with the{" "}
            <Link to={nextPillar.path}>{nextPillar.title}</Link> guide.
          </p>
        ) : null}
        <p className="guide-cta__links">
          Learn more in the <Link to="/faq">FAQ</Link>, read <Link to="/about">About Ahavibes</Link>, or review
          the <Link to="/disclaimer">Disclaimer</Link>.
        </p>
      </div>
    </div>
  </section>
);

export default GuideCTA;
